export const ru = {
  "REQUIRED_ACTION_KeepCapturing": "Продолжай захватывать.",
  "REQUIRED_ACTION_PauseCapturing": "Приостановить захват",
  "REQUIRED_ACTION_Close": "Близко",
  "REQUIRED_ACTION_Error": "Ошибка",
  "REQUIRED_ACTION_AGREE": "Согласитесь",
  "REQUIRED_ACTION_DISAGREE": "Не согласны",
  "LIVENESS_ACTION_Smile": "Улыбка",
  "LIVENESS_ACTION_Frown": "Нахмуриться",
  "LIVENESS_ACTION_Tilt Left": "Смотрите влево.",
  "LIVENESS_ACTION_Tilt Right": "Смотрите направо.",
  "LIVENESS_ACTION_Tilt Up": "Посмотреть вверх.",
  "LIVENESS_ACTION_Tilt Down": "Смотреть вниз",
  "LIVENESS_ACTION_Look Straight": "Смотрите прямо вперед.",
  "LIVENESS_ACTION_No Action": "Нет действия",
  "LIVENESS_ACTION_PROCESSING_LIVENESS": "Обработка Liveness",
  "LIVENESS_RESULT_Thank you!.Failed": "Не удалось",
  "LIVENESS_RESULT_Thank you!.Passed": "Прошло.",
  "LIVENESS_RESULT_Thank you!.ActionTimedOut": "Действие завершено.",
  "LIVENESS_RESULT_Thank you!.Interrupted": "Прерванный",
  "LIVENESS_RESULT_Thank you!.Undefined": "Неопределенный",
  "LIVENESS_ACTION_LOOK_STRAIGHT_TITLE": "Смотрите прямо перед собой",
  "LIVENESS_ACTION_LOOK_STRAIGHT_TEXT": "Постоянно смотрите на экран",
  "LIVENESS_ACTION_LOOK_LEFT_TITLE": "Поверните голову немного влево",
  "LIVENESS_ACTION_LOOK_LEFT_TEXT": "Постоянно смотрите на экран",
  "LIVENESS_ACTION_LOOK_RIGHT_TITLE": "Поверните голову немного вправо",
  "LIVENESS_ACTION_LOOK_RIGHT_TEXT": "Постоянно смотрите на экран",
  "LIVENESS_ACTION_LOOK_UP_TITLE": "Поверните голову немного вверх",
  "LIVENESS_ACTION_LOOK_UP_TEXT": "Постоянно следите за экраном",
  "LIVENESS_ACTION_LOOK_DOWN_TITLE": "Поверните голову немного вниз",
  "LIVENESS_ACTION_LOOK_DOWN_TEXT": "Постоянно смотрите на экран",
  "LIVENESS_ACTION_SMILE_TITLE": "Улыбка",
  "LIVENESS_ACTION_SMILE_TEXT": "Постоянно смотрите на экран",
  "LIVENESS_ACTION_FROWN_TITLE": "Нахмурьтесь",
  "LIVENESS_ACTION_FROWN_TEXT": "Все время следите за экраном",
  "PASSIVE_LIVENESS_ERROR_FACE_TOO_CLOSE_TITLE": "Ой-ой... Вы слишком близко.",
  "PASSIVE_LIVENESS_ERROR_FACE_CLOSE_TO_BORDER_TITLE": "Ой-ой... Вы слишком близко.",
  "PASSIVE_LIVENESS_ERROR_FACE_CROPPED_TITLE": "Что-то пошло не так. Попробуйте еще раз.",
  "PASSIVE_LIVENESS_ERROR_FACE_CROPPED": "Что-то пошло не так. Попробуйте еще раз.",
  "PASSIVE_LIVENESS_ERROR_FACE_NOT_FOUND_TITLE": "Мы не можем обнаружить лицо на изображении. Попробуйте еще раз.",
  "PASSIVE_LIVENESS_ERROR_FACE_TOO_SMALL_TITLE": "Ой-ой... Вы слишком далеко.",
  "PASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE_TITLE": "Ой-ой... Что-то пошло не так.",
  "ASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE": "Что-то пошло не так. Попробуйте еще раз.",
  "PASSIVE_LIVENESS_ERROR_TOO_MANY_FACES": "Мы не можем обнаружить лицо на изображении. Попробуйте еще раз.",
  "PASSIVE_LIVENESS_ERROR_FACE_IS_OCCLUDED_TITLE": "Ой-ой...Мы не можем обнаружить лицо.",
  "PASSIVE_LIVENESS_ERROR_UNKNOWN_TITLE": "Ой-ой...Что-то пошло не так.",
  "PASSIVE_LIVENESS_ERROR_UNKNOWN": "Что-то пошло не так. Попробуйте еще раз.",
  "PASSIVE_LIVENESS_ERROR_INTERNAL_TITLE": "Ой-ой...Что-то пошло не так.",
  "PASSIVE_LIVENESS_ERROR_INTERNAL": "Что-то пошло не так. Попробуйте еще раз.",
  "PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD_TITLE": "Ой-ой...Что-то пошло не так.",
  "PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD": "Что-то пошло не так. Попробуйте еще раз.",
  "PASSIVE_LIVENESS_ERROR_None_TITLE": "Ой-ой...Что-то пошло не так.",
  "PASSIVE_LIVENESS_ERROR_None": "Что-то пошло не так. Попробуйте еще раз.",
  "PASSIVE_LIVENESS_ERROR_FailedExpressions_TITLE": "Ой-ой...Что-то пошло не так.",
  "PASSIVE_LIVENESS_ERROR_FailedExpressions": "Что-то пошло не так. Попробуйте еще раз.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_IMAGE_TITLE": "Ой-ой...Что-то пошло не так.",
  "PASSIVE_LIVENESS_ERROR_IMAGE_ERROR_TITLE": "Ой-ой...Что-то пошло не так.",
  "PASSIVE_LIVENESS_ERROR_IMAGE_ERROR": "Что-то пошло не так. Попробуйте еще раз.",
  "PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR_TITLE": "Ой-ой...Что-то пошло не так.",
  "PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR": "Что-то пошло не так. Попробуйте еще раз.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE_TITLE": "Ой-ой...Что-то пошло не так.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE": "Что-то пошло не так. Попробуйте еще раз.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL_TITLE": "Ой-ой...Что-то пошло не так.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL": "Что-то пошло не так. Попробуйте еще раз.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE_TITLE": "Ой-ой...Что-то пошло не так.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE": "Что-то пошло не так. Попробуйте еще раз.",
  "PASSIVE_LIVENESS_ERROR_INVALID_CONFIG_TITLE": "Ой-ой...Что-то пошло не так.",
  "PASSIVE_LIVENESS_ERROR_INVALID_CONFIG": "Что-то пошло не так. Попробуйте еще раз.",
  "PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD_TITLE": "Ой-ой...Что-то пошло не так.",
  "PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD": "Что-то пошло не так. Попробуйте еще раз.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT_TITLE": "Ой-ой...Что-то пошло не так.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT": "Что-то пошло не так. Попробуйте еще раз.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT_TITLE": "Ой-ой...Что-то пошло не так.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT": "Что-то пошло не так. Попробуйте еще раз.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS_TITLE": "Ой-ой...Что-то пошло не так.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS": "Что-то пошло не так. Попробуйте еще раз.",
  "PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE_TITLE": "Ой-ой...Что-то пошло не так.",
  "PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE": "Что-то пошло не так. Попробуйте еще раз.",
  "PASSIVE_LIVENESS_ERROR_NULLPTR_TITLE": "Ой-ой...Что-то пошло не так.",
  "PASSIVE_LIVENESS_ERROR_NULLPTR": "Что-то пошло не так. Попробуйте еще раз.",
  "PASSIVE_LIVENESS_ERROR_LICENSE_ERROR_TITLE": "Ой-ой...Что-то пошло не так.",
  "PASSIVE_LIVENESS_ERROR_LICENSE_ERROR": "Что-то пошло не так. Попробуйте еще раз.",
  "PASSIVE_LIVENESS_ERROR_INVALID_META_TITLE": "Ой-ой...Что-то пошло не так.",
  "PASSIVE_LIVENESS_ERROR_INVALID_META": "Что-то пошло не так. Попробуйте еще раз.",
  "INITIALIZING_TITLE": "Инициализация",
  "INITIALIZING_DESCRIPTION": "Проверка аппаратных возможностей, пожалуйста, подождите...",
  "JOURNEY_STATE_STARTED": "Началось",
  "JOURNEY_STATE_INPROGRESS": "В процессе",
  "JOURNEY_STATE_ENDED": "Закончилось",
  "INFO_JOURNEY_STATE": "Государство",
  "INFO_JOURNEY_ACTION": "Действие",
  "INFO_JOURNEY_ACTION_ATTEMPT": "Попытка действия",
  "INFO_JOURNEY_ID": "Идентификатор поездки",
  "INFO_JOURNEY_RESULT": "Результат",
  "RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE": "Сообщение о результате",
  "RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE_VALUE": "Этот идентификатор, который вы нам дали, устарел — попробуйте что-нибудь другое",
  "INFO_JOURNEY_REFERENCE": "Ссылка",
  "FLOW_STATE_NONE": "Ни один",
  "FLOW_STATE_IDENTITY:FRONT": "Лицевая сторона",
  "FLOW_STATE_IDENTITY:BACK": "Обратная сторона",
  "FLOW_STATE_ADDRESS": "Адрес",
  "FLOW_STATE_SELFIE": "Селфи",
  "FLOW_STATE_LIVENESS": "Живость",
  "FLOW_STATE_COVID": "Covid",
  "PROVIDER_TITLE_CAMERA": "Камера",
  "PROVIDER_TITLE_CROPPER": "Обрезчик",
  "PROVIDER_TITLE_FILESYSTEM_ID": "Загрузите фотографию вашего документа, удостоверяющего личность",
  "PROVIDER_TITLE_FILESYSTEM_FACEMATCH": "Загрузите свою фотографию",
  "PROVIDER_TITLE_FILESYSTEM_ADDRESS": "Загрузите фотографию вашего подтверждения адреса",
  "PROVIDER_TITLE_FILESYSTEM_COVID": "Загрузите фотографию вашего документа о COVID",
  "PROVIDER_TITLE_GATEWAY": "Шлюз",
  "PROVIDER_TITLE_LIVENESS": "Живость",
  "PROVIDER_TITLE_LOGIN": "Вход",
  "PROVIDER_TITLE_RESULTS": "Результаты",
  "PROVIDER_TITLE_SCANNER": "Отсканируйте документ, удостоверяющий личность",
  "PROVIDER_TITLE_VIEW_ID": "Проверьте предварительный просмотр документа, удостоверяющего личность",
  "PROVIDER_TITLE_VIEW_FACEMATCH": "Проверьте предварительный просмотр вашего селфи",
  "PROVIDER_TITLE_VIEW_ADDRESS": "Проверьте предварительный просмотр вашего подтверждения адреса",
  "ROVIDER_TITLE_VIEW_COVID": "Проверьте предварительный просмотр вашего Covid",
  "PROVIDER_SUBTITLE_FILESYSTEM_ID": "Загрузите четкую фотографию вашего документа, удостоверяющего личность, которая находится в фокусе, не закрыта и обращена прямо к вам.",
  "PROVIDER_SUBTITLE_FILESYSTEM_FACEMATCH": "Загрузите свою четкую фотографию, которая находится в фокусе, не закрыта и обращена прямо к вам.",
  "PROVIDER_SUBTITLE_FILESYSTEM_ADDRESS": "Загрузите четкую фотографию вашего документа, которая находится в фокусе, не закрыта и обращена прямо к вам.",
  "PROVIDER_SUBTITLE_FILESYSTEM_COVID": "Загрузите четкую фотографию вашего документа, которая находится в фокусе, не закрыта и обращена прямо к вам.",
  "PROVIDER_SUBTITLE_SCANNER_ID": "Поместите страницу с фотографией вашего документа, удостоверяющего личность, на сканер лицевой стороной вниз.",
  "PROVIDER_SUBTITLE_VIEW_ID": "Проверьте предварительный просмотр вашего документа, который находится в фокусе, не закрыта и обращена прямо к вам.",
  "PROVIDER_SUBTITLE_VIEW_FACEMATCH": "Проверьте предварительный просмотр вашего селфи, который находится в фокусе, не закрыта и обращена прямо к вам.",
  "PROVIDER_SUBTITLE_VIEW_ADDRESS": "Проверьте предварительный просмотр вашего документа, который находится в фокусе, не закрыта и обращена прямо к вам.",
  "PROVIDER_SUBTITLE_VIEW_COVID": "Проверьте предварительный просмотр вашего документа, который находится в фокусе, не закрыта и обращена прямо к вам.",
  "PROVIDER_TITLE_SMART_CAPTURE": "Умный захват",
  "PROVIDER_TITLE_JOURNEY_SELECT": "Выберите путешествие.",
  "PROVIDER_TITLE_TERMS_AND_CONDITIONS": "Условия и положения",
  "PROVIDER_TITLE_USER_INPUT": "Пожалуйста, заполните следующую форму",
  "FILESYSTEM_SUPPORTED_TYPES_FIRST": "Поддерживаемые форматы:",
  "FILESYSTEM_SUPPORTED_TYPES_LIST": "JPG, PNG, PDF",
  "FILESYSTEM_SUPPORTED_TYPES_PDF": "PDF",
  "FILESYSTEM_SUPPORTED_TYPES_SECOND": "(в случае",
  "FILESYSTEM_SUPPORTED_TYPES_THIRD": "обрабатывается только первая страница)",
  "FILESYSTEM_SUPPORTED_TYPES_START_SELFIE": "Принимаемые форматы: JPG, PNG",
  "FILESYSTEM_MAX_FILE_SIZE": "Размер файла: мы принимаем файлы размером менее",
  "FILESYSTEM_MAX_FILE_SIZE_NUMBER": "7,5 МБ",
  "FILESYSTEM_CHECK_FILE_TOO_BIG": "Ваш файл слишком большой. Пожалуйста, загрузите файл размером менее 7,5 МБ.",
  "FILESYSTEM_CHECK_FILE_INCORRECT_FORMAT": "Ваш файл имеет неправильный формат. Пожалуйста, загрузите один из принятых форматов.",
  "FILESYSTEM_IDENTITY_DOCUMENT": "Документ, удостоверяющий личность",
  "FILESYSTEM_FACEMATCH": "Матч лиц",
  "FILESYSTEM_ADDRESS": "Подтверждение адреса",
  "FILESYSTEM_COVID": "Covid",
  "FILESYSTEM_DRAG_DROP": "Перетаскивание",
  "FILESYSTEM_OR": "или",
  "FILESYSTEM_CHOOSE": "Выберите файл",
  "FILESYSTEM_UPLOADING": "Загрузка...",
  "TRIPLESCAN_GUIDANCE_TRYAGAIN": "Попробуйте еще раз",
  "FAILURE_REASON_REFER": "Ваш документ, удостоверяющий личность, не прошел проверку.",
  "FAILURE_REASON_EXPIRED": "Срок действия вашего удостоверения личности истек.",
  "FAILURE_REASON_NOT_ACCEPTED": "Ваш документ, удостоверяющий личность, не является принятым типом документа.",
  "FAILURE_REASON_NOT_SUPPORTED": "Ваш документ, удостоверяющий личность, не может быть классифицирован или не поддерживается.",
  "PLEASE_TRY_AGAIN_REFER": "Пожалуйста, попробуйте еще раз.",
  "PLEASE_TRY_AGAIN_EXPIRED": "Пожалуйста, повторите попытку с действительным документом.",
  "PLEASE_TRY_AGAIN_NOT_ACCEPTED": "Пожалуйста, повторите попытку с другим документом.",
  "PLEASE_TRY_AGAIN_NOT_SUPPORTED": "Пожалуйста, попробуйте еще раз.",
  "BLUR_CHECK_REASON": "Размытость - документ неясен;",
  "GLARE_CHECK_REASON": "Блики - документ становится нечитаемым из-за яркого источника света;",
  "RESOLUTION_CHECK_REASON": "Низкое разрешение - документ не заполняет рамку должным образом;",
  "EDGES_CHECK_REASON": "Отсутствие краев - документ неправильно расположен в рамке;",
  "VALIDATION_FAILED": "Валидация не прошла",
  "VALIDATION_FAILED_REASON_DOC_UNKNOWN": "- Документ неизвестен.",
  "VALIDATION_FAILED_REASON_DOC_NOT_ACCEPTED": "- документ не принимается.",
  "VALIDATION_FAILED_REASON_DOC_EXPIRED": "- срок действия документа истек.",
  "PREVIEW_INFO_TITLE_ID": "Примеры хороших и плохих фотографий",
  "PREVIEW_INFO_GOOD": "Хорошо",
  "PREVIEW_INFO_BAD": "Плохой",
  "PREVIEW_INFO_GOOD_EXAMPLE_ID": "Фотография четкая, в фокусе и прямо лицом к лицу.",
  "PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ID": "На фотографии должны быть видны все четыре угла.",
  "PREVIEW_INFO_BAD_EXAMPLE_COVER_ID": "Документ не должен быть закрыт.",
  "PREVIEW_INFO_BAD_EXAMPLE_BLUR_ID": "Фотография не должна быть размытой.",
  "PREVIEW_INFO_TITLE_FACEMATCH": "Советы по созданию качественного селфи",
  "PREVIEW_INFO_GOOD_EXAMPLE_FACEMATCH": "Селфи получается четким, в фокусе и прямо лицом к лицу.",
  "PREVIEW_INFO_BAD_EXAMPLE_ANGLE_FACEMATCH": "На селфи должно быть видно все лицо.",
  "PREVIEW_INFO_BAD_EXAMPLE_COVER_FACEMATCH": "Лицо не должно быть закрыто.",
  "PREVIEW_INFO_BAD_EXAMPLE_BLUR_FACEMATCH": "Селфи не должно быть размытым.",
  "PREVIEW_INFO_TITLE_ADDRESS": "Советы по созданию качественных фотографий",
  "PREVIEW_INFO_GOOD_EXAMPLE_ADDRESS": "Фотография четкая, в фокусе и прямо лицом к лицу.",
  "PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ADDRESS": "На фотографии должны быть видны все четыре угла.",
  "PREVIEW_INFO_BAD_EXAMPLE_COVER_ADDRESS": "Документ не должен быть закрыт.",
  "PREVIEW_INFO_BAD_EXAMPLE_BLUR_ADDRESS": "Фотография не должна быть размытой.",
  "PREVIEW_INFO_TITLE_COVID": "Советы по созданию качественных фотографий",
  "PREVIEW_INFO_GOOD_EXAMPLE_COVID": "Фотография четкая, в фокусе и прямо лицом к лицу.",
  "PREVIEW_INFO_BAD_EXAMPLE_ANGLE_COVID": "На фотографии должны быть видны все четыре угла.",
  "PREVIEW_INFO_BAD_EXAMPLE_COVER_COVID": "Документ не должен быть закрыт.",
  "PREVIEW_INFO_BAD_EXAMPLE_BLUR_COVID": "Фотография не должна быть размытой.",
  "ATTEMPTS_REMAINING": "Количество оставшихся попыток:",
  "CAMERA_CAPTURE": "Включите камеру",
  "CAMERA_CAPTURE_START_BUTTON": "Начать автоматический захват",
  "CAMERA_CAPTURE_CAPTION": "Нажмите на кнопку Начать автозахват, чтобы начать",
  "CAMERA_PREVIEW_START": "Включите камеру, чтобы начать автоматическую съемку",
  "CAMERA_CONDITION_BLUR": "Обнаружено размытие",
  "CAMERA_CONDITION_CAPTURING": "Захват",
  "CAMERA_CONDITION_UPLOADING": "Загрузка... Пожалуйста, подождите",
  "CAMERA_CONDITION_ALIGNMENT": "Документ не в рамке",
  "CAMERA_CONDITION_GLARE": "Обнаружение бликов",
  "VERIFYING_TITLE": "Проверка ...",
  "PREPARING_PREVIEW_TITLE": "Подготовка к просмотру ...",
  "CAMERA_CONDITION_LOW_RESOLUTION": "Документ слишком далеко",
  "CAMERA_LOADING": "Камера открытия...",
  "CAMERA_SMARTCAPTURE_ON": "АВТОМАТИЧЕСКИЙ ЗАХВАТ - ВКЛ.",
  "CAMERA_SMARTCAPTURE_OFF": "АВТОМАТИЧЕСКАЯ СЪЕМКА - ВЫКЛ.",
  "CAMERA_CAPTURE_FRONT": "Разместите сторону с фотографией вашего удостоверения личности в рамке ниже.",
  "CAMERA_MANUAL_CAPTURE_FRONT": "Расположите документ, удостоверяющий личность, в рамке и нажмите на кнопку ниже",
  "CAMERA_CAPTURE_BACK": "Расположите заднюю часть документа, удостоверяющего личность, в рамке",
  "CAMERA_CAPTURE_SELFIE_CAPTION": "Расположите лицо в овале, посмотрите прямо в камеру и нажмите на кнопку внизу, чтобы сделать селфи.",
  "AMERA_CAPTURE_ADDRESS_CAPTION": "Расположите документ, подтверждающий адрес, в рамке и нажмите на кнопку ниже, чтобы сделать снимок.",
  "CAMERA_CAPTURE_COVID_CAPTION": "Расположите документ Covid в рамке и нажмите на кнопку ниже, чтобы сделать снимок.",
  "CAMERA_PREVENT_GLARE_HINT": "Переместите документ подальше от прямых источников света.",
  "CAMERA_PREVENT_BLUR_HINT": "Держите документ или устройство ровно.",
  "CAMERA_PREVENT_LOW_RES_HINT": "Полностью вставьте документ в рамку.",
  "CROPPER_RETRY": "Повторная попытка",
  "CROPPER_UPLOAD": "Загрузить",
  "CROPPER_UPLOADING": "Загрузка...",
  "FILESYSTEM_SELECT": "Выберите",
  "FILESYSTEM_DROP_IMAGE": "или Падение изображения",
  "GATEWAY_CAMERA": "Камера включена",
  "GATEWAY_CANCEL": "Отменить поездку",
  "LIVENESS_START": "Начало Liveness",
  "PASSIVE_LIVENESS_START": "Сделать снимок",
  "LOGIN_USERNAME": "Имя пользователя",
  "LOGIN_PASSWORD": "Пароль",
  "LOGIN_SUBMIT": "Отправить",
  "RESULTS_DOCUMENTS": "Документы",
  "RESULTS_DOCUMENTS_NONE": "Ничего не найдено",
  "RESULTS_DOCUMENT_TYPE": "Тип документа",
  "RESULTS_DOCUMENT_RESULT": "Результат документа",
  "RESULTS_EXTRACTED_FIELDS_NONE": "Сведения о результате",
  "RESULTS_DETAILS_NONE": "Ничего не найдено",
  "RESULTS_NEW_JOURNEY": "Начать новое путешествие.",
  "RESULTS_NO_INFORMATION": "Нет информации об этом путешествии",
  "RESULTS_LOGOUT": "Выход",
  "RESULTS_HIGH_LEVEL_Aborted": "Прервано",
  "RESULTS_HIGH_LEVEL_TCCDISAGREE": "Отмененные положения и условия",
  "RESULTS_HIGH_LEVEL_Expired": "Истекший",
  "RESULTS_HIGH_LEVEL_NotAccepted": "Не принято.",
  "RESULTS_HIGH_LEVEL_NotSupported": "Не поддерживается",
  "RESULTS_HIGH_LEVEL_Notsupported": "Не поддерживается",
  "RESULTS_HIGH_LEVEL_Passed": "Прошло.",
  "RESULTS_HIGH_LEVEL_Refer": "Ссылка",
  "RESULTS_HIGH_LEVEL_Undefined": "Неопределенный",
  "RESULTS_HIGH_LEVEL_DETAIL_ACCUMULATIVELIVENESSRESULT": "Накопительный результат живучести",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTFRONTSIDETYPECHECK": "Проверка типа лицевой стороны документа",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBACKSIDECHECK": "Проверка обратной стороны документа",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBLOCKINGPOLICY": "Политика блокировки документов",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTEXPIRY": "Срок действия документа",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTSUPPORT": "Поддержка документов",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTVALIDATION": "Проверка документов",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTPROOFPOLICY": "Политика подтверждения документов",
  "RESULTS_HIGH_LEVEL_DETAIL_FACEMATCHVALIDATION": "Проверка совпадения лиц",
  "RESULTS_HIGH_LEVEL_DETAIL_UNDERAGERULE": "Правило о несовершеннолетних",
  "ESULTS_HIGH_LEVEL_DETAIL_VALUE_SUCCESS_NEEDED": "Необходимый успех",
  "RESULTS_HIGH_LEVEL_DETAIL_COVID_PASS_CROSSCHECK": "Проверка совместимости паспорта Covid",
  "RESULTS_HIGH_LEVEL_DETAIL_DATA_CHECK": "Проверки данных",
  "RESULTS_HIGH_LEVEL_DETAIL_VALUE_FAILED": "Не удалось",
  "RESULTS_HIGH_LEVEL_DETAIL_VALUE_NOTNEEDED": "Не нужно.",
  "RESULTS_HIGH_LEVEL_DETAIL_VALUE_PASSED": "Прошло.",
  "RESULTS_HIGH_LEVEL_DETAIL_VALUE_SKIPPED": "Пропущено",
  "RESULTS_HIGH_LEVEL_DETAIL_VALUE_UNDETERMINED": "Неопределенный",
  "ADDITIONAL_CHECKS_DETAILS": "Дополнительные проверки",
  "ADDITIONAL_CHECKS_DETAILS_NONE": "Не найдено",
  "ADDITIONAL_CHECKS_DETAIL_DATACHECKS": "Проверки данных",
  "ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK": "Проверки обратного хода",
  "ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK_NA": "N/A",
  "GBG_SCORES": "Баллы GBG",
  "GBG_TRUST_SCORE": "GBG Trust Score",
  "GBG_SCORE": "Балл GBG",
  "VIEW_RETRY": "Фотография изменений",
  "VIEW_CROP": "Урожай",
  "VIEW_CROPPING": "Обрезка...",
  "VIEW_UPLOAD": "Загрузить",
  "VIEW_UPLOADING": "Загрузка...",
  "SMART_CAPTURE_INITIALIZING": "Начало",
  "SMART_CAPTURE_START": "Инициализация Smart Capture, Пожалуйста, подождите...",
  "SCANNER_DESC_AVAILABLE": "Сканер доступен. Положите ваш документ на сканер.",
  "SCANNER_DESC_PROCESSING": "Изображение обрабатывается сервером.",
  "SCANNER_DESC_SCANNING": "Изображение сканируется устройством.",
  "SCANNER_DESC_DISCONNECTED": "Сканер отключен от сети.",
  "SCANNER_DESC_NOT_CONNECTED": "Сканер не подключен.",
  "SCANNER_DESC_OFFLINE": "Сканер отключен.",
  "SCANNER_DESC_BUSY": "Сканер используется другим пользователем в вашей локальной сети.",
  "SCANNER_DESC_WAITING": "Ожидание установления соединения.",
  "SCANNER_DESC_LOADING": "Пожалуйста, подождите...",
  "SCANNER_TITLE_SCANNING": "СКАНИРОВАНИЕ...",
  "SCANNER_TITLE_DISCONNECTED": "НЕПОДКЛЮЧЕННЫЙ",
  "SCANNER_TITLE_NOT_CONNECTED": "НЕ ПОДКЛЮЧЕНо",
  "SCANNER_TITLE_OFFLINE": "Сканер в автономном режиме",
  "SCANNER_TITLE_BUSY": "Сканер занят",
  "SCANNER_TITLE_WAITING": "ОЖИДАНИЕ",
  "SCANNER_ACTION_REGISTER": "Регистрация",
  "SCANNER_ACTION_RELEASE": "Выпуск",
  "CANCEL_JOURNEY": "Отменить",
  "MANUAL_PHOTO_UPLOAD_TOGGLE_FALSE": "Загрузите фотографию",
  "MANUAL_PHOTO_UPLOAD_TOGGLE_TRUE": "Сделать фотографию вместо этого",
  "JOURNEY_SELECT_CONTINUE": "Продолжить",
  "HELP_MODAL_AUTOCAPTURE_TITLE": "Как сфотографировать документ, удостоверяющий личность",
  "HELP_MODAL_AUTOCAPTURE_SUBTITLE": "Если включен режим автозахвата, экран захвата автоматически сфотографирует ваш документ, когда определит, что он достаточно качественный.",
  "HELP_MODAL_AUTOCAPTURE_TIPS": "Советы по созданию качественной фотографии",
  "HELP_MODAL_AUTOCAPTURE_GLARE_TITLE": "Не допускайте бликов",
  "HELP_MODAL_AUTOCAPTURE_GLARE_SUBTITLE": "Переместите документ подальше от прямых источников света.",
  "HELP_MODAL_AUTOCAPTURE_FAR_TITLE": "Документ слишком далеко",
  "AUTOCAPTURE_FAR_SUBTITLE": "Полностью поместите документ в рамку.",
  "AUTOCAPTURE_BLUR_TITLE": "Предотвращение размытия",
  "HELP_MODAL_AUTOCAPTURE_BLUR_SUBTITLE": "Держите документ или устройство ровно.",
  "HELP_MODAL_AUTOCAPTURE_MANUAL_CAPTURE": "Не получается? Сделайте снимок с помощью функции «Ручной захват",
  "HELP_MODAL_AUTOCAPTURE_TURN_MANUAL_CAPTURE": "Ручная съемка",
  "HELP_MODAL_SELFIE_TITLE": "Как сделать селфи",
  "HELP_MODAL_SELFIE_SUBTITLE": "Посмотрите прямо в камеру и нажмите на кнопку ручной съемки.",
  "HELP_MODAL_POA_TITLE": "Как сфотографировать документ, подтверждающий адрес",
  "HELP_MODAL_POA_SUBTITLE": "Расположите документ в рамке и нажмите на кнопку захвата, чтобы сфотографировать его.",
  "HELP_MODAL_POA_TIPS": "Советы по созданию качественных фотографий",
  "HELP_MODAL_POA_GLARE_TITLE": "Не допускайте бликов",
  "HELP_MODAL_POA_GLARE_SUBTITLE": "Переместите документ подальше от прямых источников света.",
  "HELP_MODAL_POA_FAR_TITLE": "Документ слишком далеко",
  "HELP_MODAL_POA_FAR_SUBTITLE": "Полностью поместите документ в рамку.",
  "HELP_MODAL_POA_BLUR_TITLE": "Предотвращение размытия",
  "HELP_MODAL_POA_BLUR_SUBTITLE": "Держите документ или устройство ровно.",
  "HELP_MODAL_POA_MANUAL_CAPTURE": "Не получается? Включите ручной захват",
  "HELP_MODAL_POA_TURN_MANUAL_CAPTURE": "Ручной захват",
  "HELP_MODAL_COVID_TITLE": "Как сфотографировать документ Covid",
  "HELP_MODAL_COVID_SUBTITLE": "Расположите документ в рамке и нажмите на кнопку захвата, чтобы сделать снимок документа.",
  "HELP_MODAL_COVID_TIPS": "Советы по созданию качественных снимков",
  "HELP_MODAL_COVID_GLARE_TITLE": "Не допускайте бликов",
  "HELP_MODAL_COVID_GLARE_SUBTITLE": "Переместите документ подальше от прямых источников света.",
  "HELP_MODAL_COVID_FAR_TITLE": "Документ слишком далеко",
  "HELP_MODAL_COVID_FAR_SUBTITLE": "Полностью поместите документ в рамку.",
  "HELP_MODAL_COVID_BLUR_TITLE": "Предотвращение размытия",
  "HELP_MODAL_COVID_BLUR_SUBTITLE": "Держите документ или устройство ровно.",
  "HELP_MODAL_COVID_MANUAL_CAPTURE": "Все еще боретесь? Включите ручной захват",
  "HELP_MODAL_COVID_TURN_MANUAL_CAPTURE": "Ручной захват",
  "HELP_MODAL_NEED_HELP": "Нужна помощь?",
  "EXCEPTION": "Произошло неожиданное исключение",
  "EXCEPTION_AUTHORIZATION": "Неавторизованный",
  "EXCEPTION_AUTHORIZATION_ACCOUNT_NOT_AUTHORIZED": "Ваша учетная запись не авторизована для доступа к этому ресурсу",
  "EXCEPTION_AUTHORIZATION_AUTH_DETAILS_INVALID": "Комбинация имени пользователя и пароля недействительна",
  "EXCEPTION_AUTHORIZATION_AUTH_NOT_ENABLED": "Вы должны включить авторизацию, чтобы использовать эту функциональность",
  "EXCEPTION_AUTHORIZATION_PROCESS_NOT_AUTHORIZED": "Вы не авторизованы для этого процесса",
  "EXCEPTION_BAD_REQUEST": "Плохой запрос с кодом состояния 400",
  "EXCEPTION_BAD_REQUEST_INVALID_IMAGE": "Недействительное изображение",
  "EXCEPTION_BAD_REQUEST_WAITING_FOR_RESPONSE": "Путешествие ожидает ответа",
  "EXCEPTION_FLOW_STATE_JOURNEY_ENDED": "Невозможно отправить запрос. Путешествие закончилось",
  "EXCEPTION_FLOW_STATE_MISSING": "Состояние потока не найдено",
  "EXCEPTION_INVALID_PARAMETER_CALLBACK_MUST_BE_FUNCTION": "Callback должен быть действительной функцией.",
  "EXCEPTION_INVALID_PARAMETER_NAME_MUST_BE_STRING": "Имя события должно быть строковым значением.",
  "EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_NUMBER": "Приоритет должен быть числом.",
  "EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_POSITIVE_NUMBER": "Приоритет должен быть положительным числом.",
  "EXCEPTION_INVALID_PARAMETER_SHOULD_BE_ELEMENT_OR_SELECTOR": "Контейнер должен быть либо элементом, либо селектором.",
  "EXCEPTION_INVALID_PARAMETER_VALUE_NOT_VALID": "Значение недействительно.",
  "EXCEPTION_INVALID_PARAMETER_VALUE_DAMAGED": "Значение было повреждено.",
  "EXCEPTION_MISSING_PARAMETER_BACKEND_URL_MISSING": "Конфигурация должна включать параметр backendUrl.",
  "EXCEPTION_MISSING_PARAMETER_COORDINATES_MISSING": "Поставляемые параметры должны содержать координаты.",
  "EXCEPTION_MISSING_PARAMETER_IMAGES_MISSING": "Предоставленные параметры должны содержать изображения.",
  "EXCEPTION_MISSING_PARAMETER_PASSWORD_MISSING": "Предоставленные параметры должны содержать пароль.",
  "EXCEPTION_MISSING_PARAMETER_USERNAME_MISSING": "Предоставленные параметры должны содержать имя пользователя.",
  "EXCEPTION_MISSING_REQUIRED_FIELD_MISSING": "Пожалуйста, заполните все необходимые поля",
  "EXCEPTION_POSTCODE_FORMAT_ERROR": "Формат почтового индекса недействителен minLength:5 / maxLength:8",
  "EXCEPTION_HOUSENUMBER_FORMAT_ERROR": "Название/номер дома не действителен minLength:1 / maxLength:20",
  "EXCEPTION_STREETNAME_FORMAT_ERROR": "Название улицы недействительно minLength:1 / maxLength:30",
  "EXCEPTION_TOWN_FORMAT_ERROR": "Формат города не действителен minLength:1 / maxLength:20",
  "EXCEPTION_JOURNEY_DEFINITIONS_MISSING": "Для этого канала нет определений поездок",
  "EXCEPTION_NETWORK": "Произошло сетевое исключение, пожалуйста, проверьте соединение и повторите попытку",
  "EXCEPTION_PLATFORM_BROWSER_ONLY": "Эта функция может быть использована только в браузере",
  "EXCEPTION_PLATFORM_UNSUPPORTED": "Ваша среда не поддерживает эту функцию",
  "EXCEPTION_PLATFORM_CAMERA_PERMISSION_DENIED": "Разрешения на камеру не были предоставлены, проверьте настройки браузера",
  "EXCEPTION_PLATFORM_CAMERA_PERMISSION_UNAVAILABLE": "Разрешения на камеру недоступны",
  "EXCEPTION_PLATFORM_CAMERA_NOT_READABLE": "Не удалось получить доступ к камере. Пожалуйста, закройте все другие приложения и повторите попытку",
  "EXCEPTION_PLATFORM_CAMERA_NONE_SUITABLE": "На вашем устройстве не найдено подходящих камер",
  "EXCEPTION_SERVER": "Запрос не выполнен с кодом состояния 500",
  "EXCEPTION_SERVER_UNREACHABLE": "Запрос не выполнен, сервер недоступен",
  "EXCEPTION_SERVER_DATA_NOT_PERSISTED": "Во время процесса произошла ошибка. Ваши данные могут не сохраниться",
  "EXCEPTION_SERVER_RESULT_NOT_PASSING": "Текущий результат не передается",
  "EXCEPTION_TEMPLATE_CANVAS_CONTEXT_UNAVAILABLE": "Контекст холста недоступен",
  "EXCEPTION_TEMPLATE_CONTAINER_MISSING": "Контейнер отсутствует",
  "EXCEPTION_TEMPLATE_ELEMENTS_MISSING": "Отсутствуют необходимые элементы",
  "EXCEPTION_TEMPLATE_MISSING": "Шаблон не найден",
  "EXCEPTION_TEMPLATE_SOURCE_ELEMENT_MISSING": "Невозможно найти исходный элемент",
  "EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_CANNOT_RETRIEVE": "Невозможно получить поставщиков входных данных",
  "EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NONE_SPECIFIED": "Не указаны поставщики входных данных",
  "EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NOT_AVAILABLE": "Провайдер ввода недоступен",
  "SUPPORTED_DOCUMENT_Account Statement": "Выписка по счету",
  "SUPPORTED_DOCUMENT_Agreement (Tenancy)": "Соглашение (Аренда)",
  "SUPPORTED_DOCUMENT_Bank Document": "Банковский документ",
  "SUPPORTED_DOCUMENT_Bank Letter": "Банковское письмо",
  "SUPPORTED_DOCUMENT_Bank Statement": "Выписка из банка",
  "SUPPORTED_DOCUMENT_Benefit Letter": "Письмо о льготах",
  "SUPPORTED_DOCUMENT_Certificate (Birth, Marriage, Civil partnership)": "Свидетельство (о рождении, о браке, о гражданском партнерстве)",
  "SUPPORTED_DOCUMENT_Council Document": "Документ Совета",
  "SUPPORTED_DOCUMENT_Council Letter": "Письмо Совета",
  "SUPPORTED_DOCUMENT_Council Tax": "Налог на жилище",
  "SUPPORTED_DOCUMENT_Driving License": "Водительское удостоверение",
  "SUPPORTED_DOCUMENT_Driving Licence": "Водительское удостоверение",
  "SUPPORTED_DOCUMENT_DWP Document": "Документ DWP",
  "SUPPORTED_DOCUMENT_HMRC Document": "Документ HMRC",
  "SUPPORTED_DOCUMENT_Information Sheet": "Информационный лист",
  "SUPPORTED_DOCUMENT_Insurance Document": "Страховой документ",
  "SUPPORTED_DOCUMENT_Insurance Letter": "Страховое письмо",
  "SUPPORTED_DOCUMENT_Invoice": "Счет",
  "SUPPORTED_DOCUMENT_NIC Letter": "Письмо NIC",
  "SUPPORTED_DOCUMENT_NINO Letter": "Письмо НИНО",
  "SUPPORTED_DOCUMENT_Official Document": "Официальный документ",
  "SUPPORTED_DOCUMENT_Official Letter": "Официальное письмо",
  "SUPPORTED_DOCUMENT_Repayment Letter (related to Tax or Social support)": "Письмо о возврате (связанное с налогами или социальной поддержкой)",
  "SUPPORTED_DOCUMENT_Tax Letter": "Налоговое письмо",
  "SUPPORTED_DOCUMENT_Tax Statement": "Налоговая декларация",
  "SUPPORTED_DOCUMENT_Tel Bill": "Счет за телефон",
  "SUPPORTED_DOCUMENT_Tel Letter": "Письмо по телефону",
  "SUPPORTED_DOCUMENT_Telecommunication Document": "Документ о телекоммуникациях",
  "SUPPORTED_DOCUMENT_TV Licence": "Телевизионная лицензия",
  "SUPPORTED_DOCUMENT_University Letter": "Университетское письмо",
  "SUPPORTED_DOCUMENT_Utility Bill": "Квитанция за коммунальные услуги",
  "SUPPORTED_DOCUMENT_Utility Document": "Утилитарный документ",
  "SUPPORTED_DOCUMENT_Utility Letter": "Утилитарное письмо.",
  "SUPPORTED_DOCUMENT_Water Bil": "Водяной Бил",
  "SUPPORTED_DOCUMENT_Water Document": "Водный документ",
  "SUPPORTED_DOCUMENT_Agents License": "Лицензия агента",
  "SUPPORTED_DOCUMENT_Electoral Card": "Избирательная карта",
  "SUPPORTED_DOCUMENT_Foreigner Identification Card": "Карта идентификации иностранца",
  "SUPPORTED_DOCUMENT_Health Card": "Карта здоровья",
  "SUPPORTED_DOCUMENT_Job License": "Рабочая лицензия",
  "SUPPORTED_DOCUMENT_Membership Identification Card": "Удостоверение членства",
  "SUPPORTED_DOCUMENT_Military Identification Card": "Военный идентификационный документ",
  "SUPPORTED_DOCUMENT_National Identification Card": "Национальная идентификационная карта",
  "SUPPORTED_DOCUMENT_Passport": "Паспорт",
  "SUPPORTED_DOCUMENT_Travel Permit": "Разрешение на путешествие",
  "SUPPORTED_DOCUMENT_Visa": "Виза",
  "SUPPORTED_DOCUMENT_Weapons Licence": "Лицензия на оружие",
  "SUPPORTED_DOCUMENT_Selfie Photo": "Селфи фото",
  "SUPPORTED_DOCUMENT_Unknown": "Неизвестно.",
  "SUPPORTED_DOCUMENT_COVIDPAS": "Перевал Ковида",
  "EXTRACTED_FIELDS_AddressFull": "Адрес полный",
  "EXTRACTED_FIELDS_AddressCity": "Адрес Город",
  "EXTRACTED_FIELDS_AddressPostCode": "Адрес Почтовый Индекс",
  "EXTRACTED_FIELDS_LastNameFirstPart": "Фамилия Первая Часть",
  "EXTRACTED_FIELDS_Sex": "Гендер",
  "EXTRACTED_FIELDS_BirthPlace": "Место рождения",
  "EXTRACTED_FIELDS_IssueNumber": "Номер выпуска",
  "EXTRACTED_FIELDS_DocumentNumberCheckDigit": "Контрольная цифра номера документа",
  "EXTRACTED_FIELDS_BirthDate": "Дата рождения",
  "EXTRACTED_FIELDS_DocumentNumber": "Номер документа",
  "EXTRACTED_FIELDS_FirstName": "Имя",
  "EXTRACTED_FIELDS_ArbitraryDigit": "Произвольная цифра",
  "EXTRACTED_FIELDS_FirstNameInitial": "Первая буква имени",
  "EXTRACTED_FIELDS_ExpiryDate": "Срок годности",
  "EXTRACTED_FIELDS_IssueDate": "Дата выпуска",
  "EXTRACTED_FIELDS_LastName": "Фамилия",
  "EXTRACTED_FIELDS_LicenseCategory": "Категория лицензии",
  "EXTRACTED_FIELDS_DocumentCategory": "Категория документа",
  "EXTRACTED_FIELDS_DocumentType": "Тип документа",
  "EXTRACTED_FIELDS_NationalityCode": "Код национальности",
  "EXTRACTED_FIELDS_MiddleName": "Отчество",
  "EXTRACTED_FIELDS_FirstIssuanceDate": "Дата первого выпуска",
  "EXTRACTED_FIELDS_SecondLastName": "Вторая фамилия",
  "EXTRACTED_FIELDS_FullName": "Полное имя",
  "EXTRACTED_FIELDS_PersonalNumber": "Персональный номер",
  "EXTRACTED_FIELDS_NationalityName": "Национальность",
  "EXTRACTED_FIELDS_BarcodeItems": "Штрихкоды",
  "EXTRACTED_FIELDS_BirthPlaceCity": "Город рождения",
  "EXTRACTED_FIELDS_BirthPlaceState": "Место рождения",
  "EXTRACTED_FIELDS_BirthPlaceCountry": "Страна рождения",
  "EXTRACTED_FIELDS_MRZFull": "Полный MRZ",
  "EXTRACTED_FIELDS_MRZLine1": "MRZ Строка 1",
  "EXTRACTED_FIELDS_MRZLine2": "MRZ Строка 2",
  "EXTRACTED_FIELDS_MRZLine3": "MRZ Строка 3",
  "EXTRACTED_FIELDS_ObservationPage": "Наблюдение Страница",
  "EXTRACTED_FIELDS_IssuingAuthority": "Орган выдачи",
  "EXTRACTED_FIELDS_IssuingLocation": "Место выдачи",
  "EXTRACTED_FIELDS_MaritalStatus": "Семейное положение",
  "EXTRACTED_FIELDS_Occupation": "Занятие",
  "EXTRACTED_FIELDS_AlienNumber": "Инопланетное число",
  "EXTRACTED_FIELDS_Employer": "Работодатель",
  "EXTRACTED_FIELDS_AddressLine1": "Адресная строка 1",
  "EXTRACTED_FIELDS_AddressLine2": "Адресная строка 2",
  "EXTRACTED_FIELDS_AddressLine3": "Адресная строка 3",
  "EXTRACTED_FIELDS_AddressLine4": "Адресная строка 4",
  "EXTRACTED_FIELDS_AddressState": "Государство",
  "EXTRACTED_FIELDS_AddressDistrict": "Район",
  "EXTRACTED_FIELDS_AddressBuildingNumber": "Номер здания",
  "EXTRACTED_FIELDS_AddressBuildingName": "Название здания",
  "EXTRACTED_FIELDS_AddressStreet": "Улица",
  "EXTRACTED_FIELDS_AddressCountry": "Страна",
  "EXTRACTED_FIELDS_RefAddressFull": "Ссылка на адрес",
  "EXTRACTED_FIELDS_RefAddressLine1": "Адрес для справок Строка 1",
  "EXTRACTED_FIELDS_RefAddressLine2": "Адрес для справки, строка 2",
  "EXTRACTED_FIELDS_RefAddressLine3": "Ссылка Адрес Строка 3",
  "EXTRACTED_FIELDS_RefAddressLine4": "Ссылка Адрес Строка 4",
  "EXTRACTED_FIELDS_RefAddressCity": "Ссылка Адрес Город",
  "EXTRACTED_FIELDS_RefAddressState": "Ссылка Адрес Государство",
  "EXTRACTED_FIELDS_RefAddressDistrict": "Ссылочный адрес район",
  "EXTRACTED_FIELDS_RefAddressBuildingNumber": "Адрес Ссылка Номер Здания",
  "EXTRACTED_FIELDS_RefAddressBuildingName": "Адрес для справок Название здания",
  "EXTRACTED_FIELDS_RefAddressSubBuildingName": "Адрес справки Название здания",
  "EXTRACTED_FIELDS_RefAddressStreet": "Адрес для справки Улица",
  "EXTRACTED_FIELDS_RefAddressCountry": "Ссылка Адрес Страна",
  "EXTRACTED_FIELDS_RefAddressPostCode": "Адрес для справки Почтовый индекс",
  "EXTRACTED_FIELDS_HealthNumber": "Номер здоровья",
  "EXTRACTED_FIELDS_Endorsements": "Рекомендации",
  "EXTRACTED_FIELDS_Constraints": "Ограничения",
  "EXTRACTED_FIELDS_LicenseMarine": "Лицензия Морская",
  "EXTRACTED_FIELDS_Height": "Высота",
  "EXTRACTED_FIELDS_Weight": "Вес",
  "EXTRACTED_FIELDS_HairColor": "Цвет волос",
  "EXTRACTED_FIELDS_EyeColor": "Цвет глаз",
  "EXTRACTED_FIELDS_LensData": "Зрение",
  "EXTRACTED_FIELDS_SocialSecurityNumber": "Номер социального страхования",
  "EXTRACTED_FIELDS_NationalInsuranceNumber": "Национальный страховой номер",
  "EXTRACTED_FIELDS_Race": "Гонка",
  "EXTRACTED_FIELDS_MotherName": "Имя матери",
  "EXTRACTED_FIELDS_FatherName": "Имя отца",
  "EXTRACTED_FIELDS_Parents": "Родители",
  "EXTRACTED_FIELDS_Remarks": "Замечания",
  "EXTRACTED_FIELDS_DistinguishingMarks": "Отличительные черты",
  "EXTRACTED_FIELDS_PeriodOfStay": "Период пребывания",
  "EXTRACTED_FIELDS_TaxNumber": "Налоговый номер",
  "EXTRACTED_FIELDS_Donor": "Донор",
  "EXTRACTED_FIELDS_RFIDG1": "RFID Сырые Данные Группа 1",
  "EXTRACTED_FIELDS_RFIDG2": "RFID Сырые Данные Группа 2",
  "EXTRACTED_FIELDS_RFIDG3": "RFID Сырые Данные Группа 3",
  "EXTRACTED_FIELDS_RFIDG15": "RFID Сырые Данные Группа 4",
  "EXTRACTED_FIELDS_RFIDSOD": "RFID Сырые Данные Группа 5",
  "EXTRACTED_FIELDS_PortraitPhoto": "Извлеченное портретное фото",
  "EXTRACTED_FIELDS_Title": "Заголовок",
  "EXTRACTED_FIELDS_IssueDate2": "Дата второго выпуска",
  "EXTRACTED_FIELDS_ExpiryDate2": "Вторая дата истечения.",
  "EXTRACTED_FIELDS_LicenseCategory2": "Вторая категория лицензии",
  "EXTRACTED_FIELDS_IssueDate3": "Третья дата выпуска",
  "EXTRACTED_FIELDS_ExpiryDate3": "Третья дата истечения.",
  "EXTRACTED_FIELDS_LicenseCategory3": "Третья категория лицензии",
  "EXTRACTED_FIELDS_IssueDate4": "Дата четвертого выпуска",
  "EXTRACTED_FIELDS_ExpiryDate4": "Четвертая дата истечения.",
  "EXTRACTED_FIELDS_LicenseCategory4": "Четвертая категория лицензии",
  "EXTRACTED_FIELDS_MRZCode1": "Код MRZ 1",
  "EXTRACTED_FIELDS_MRZCode2": "Код MRZ 2",
  "EXTRACTED_FIELDS_MRZStandardType": "Стандарт MRZ типа",
  "EXTRACTED_FIELDS_AddressStreetSuffix": "Суффикс улицы",
  "EXTRACTED_FIELDS_AddressStreetType": "Тип улицы",
  "EXTRACTED_FIELDS_AddressUnitNumber": "Адрес Единица Номер",
  "EXTRACTED_FIELDS_LicenseNumber": "Номер лицензии",
  "EXTRACTED_FIELDS_AddressStateCode": "Государственный кодекс",
  "EXTRACTED_FIELDS_AddressStreetTypeAbbreviation": "Улица Аббревиатура",
  "EXTRACTED_FIELDS_AddressUnitType": "Тип адресного блока",
  "EXTRACTED_FIELDS_AddressDeliveryPointIdentifier": "Идентификатор точки доставки",
  "EXTRACTED_FIELDS_AgeCategory": "Возрастная категория",
  "EXTRACTED_FIELDS_ChildernCount": "Количество детей",
  "EXTRACTED_FIELDS_EntryMode": "Режим ввода",
  "EXTRACTED_FIELDS_VAFNumber": "Номер VAF",
  "EXTRACTED_FIELDS_AddressLine5": "Адресная строка 5",
  "EXTRACTED_FIELDS_RFIDPortraitPhoto": "RFID портретное фото",
  "EXTRACTED_FIELDS_RefAddressLine5": "Ссылка Адрес Строка 5",
  "EXTRACTED_FIELDS_RefAddressStateCode": "Ссылка Адрес Государство",
  "EXTRACTED_FIELDS_RefAddressStreetType": "Адресная улица тип",
  "EXTRACTED_FIELDS_RefAddressStreetTypeAbbreviation": "Аббревиатура типа улицы адреса для справки",
  "EXTRACTED_FIELDS_RefAddressStreetSuffix": "Суффикс улицы адреса ссылки",
  "EXTRACTED_FIELDS_RefAddressUnitNumber": "Номер адресного блока.",
  "EXTRACTED_FIELDS_RefAddressUnitType": "Ссылочный адрес типа блока",
  "EXTRACTED_FIELDS_RefAddressPostcodeType": "Адрес Ссылка Почтовый индекс Тип",
  "EXTRACTED_FIELDS_RefAddressDeliveryPointIdentifier": "Идентификатор точки доставки адреса для ссылки",
  "EXTRACTED_FIELDS_RefAddressPOBoxNumber": "Адрес для справок, номер почтового ящика.",
  "EXTRACTED_FIELDS_RefAddressDependentLocality": "Адрес Относительного Местоположения.",
  "EXTRACTED_FIELDS_RefAddressDoubleDependentLocality": "Ссылочный адрес двойной зависимой локации",
  "EXTRACTED_FIELDS_RefAddressThoroughfare": "Адрес улица",
  "EXTRACTED_FIELDS_RefAddressThoroughfareDesc": "Адрес справки Описание улицы",
  "EXTRACTED_FIELDS_RefAddressDependentThoroughfare": "Ссылочный адрес Зависимая проезжая часть",
  "EXTRACTED_FIELDS_RefAddressDependentThoroughfareDesc": "Описание улицы, зависящее от адреса.",
  "EXTRACTED_FIELDS_RefAddressSubBuildingNumber": "Адрес справочный, здание, номер подъезда",
  "EXTRACTED_FIELDS_AddressSubBuildingNumber": "Номер здания.",
  "EXTRACTED_FIELDS_AddressSubBuildingName": "Название здания",
  "EXTRACTED_FIELDS_AddressPostCodeType": "Тип почтового индекса",
  "EXTRACTED_FIELDS_IssuingAuthorityType": "Тип органа, выдавшего документ",
  "EXTRACTED_FIELDS_Signature": "Подпись",
  "EXTRACTED_FIELDS_Hologram": "Голограмма",
  "EXTRACTED_FIELDS_CardNumber": "Номер карты",
  "EXTRACTED_FIELDS_MiddleNameInitial": "Отчество начальное",
  "EXTRACTED_FIELDS_PermitNumber": "Номер разрешения",
  "EXTRACTED_FIELDS_ReferenceNumber": "Номер ссылки",
  "EXTRACTED_FIELDS_CustomerNumber": "Номер клиента",
  "EXTRACTED_FIELDS_BOSNumber": "Номер BOS",
  "EXTRACTED_FIELDS_StudentID": "Номер студенческого билета",
  "EXTRACTED_FIELDS_MembershipNumber": "Номер участника",
  "EXTRACTED_FIELDS_LicenseType": "Тип лицензии",
  "EXTRACTED_FIELDS_LicenseType2": "Тип лицензии 2",
  "EXTRACTED_FIELDS_LicenseType3": "Тип лицензии 3",
  "EXTRACTED_FIELDS_LicenseType4": "Тип лицензии 4",
  "EXTRACTED_FIELDS_DocumentTypeCode": "Тип документа",
  "EXTRACTED_FIELDS_MRZDocumentNumberCheckDigit": "Контрольная цифра MRZ",
  "EXTRACTED_FIELDS_MRZBirthDateCheckDigit": "Контрольная цифра даты рождения MRZ",
  "EXTRACTED_FIELDS_MRZExpiryDateCheckDigit": "Контрольная цифра срока действия MRZ",
  "EXTRACTED_FIELDS_MRZPersonalNumberCheckDigit": "Контрольная цифра личного номера MRZ",
  "EXTRACTED_FIELDS_MRZCompositeCheckDigit": "Контрольная цифра составного MRZ",
  "EXTRACTED_FIELDS_SecondaryPortraitPhoto": "Вторичное портретное фото",
  "EXTRACTED_FIELDS_Fingerprint": "Отпечаток.",
  "EXTRACTED_FIELDS_VersionNumber": "Номер версии",
  "EXTRACTED_FIELDS_Conditions": "Условия",
  "EXTRACTED_FIELDS_NickName": "Псевдоним",
  "EXTRACTED_FIELDS_AddressApartmentNumber": "Номер квартиры",
  "EXTRACTED_FIELDS_AddressFloorNumber": "Номер этажа",
  "EXTRACTED_FIELDS_FirstNameLocal": "Имя на местном языке",
  "EXTRACTED_FIELDS_LastNameLocal": "Фамилия Местная",
  "EXTRACTED_FIELDS_FullNameLocal": "Полное имя на местном языке",
  "EXTRACTED_FIELDS_BirthPlaceLocal": "Место рождения местный",
  "EXTRACTED_FIELDS_IssuingAuthorityLocal": "Орган, выдавший документ",
  "EXTRACTED_FIELDS_MotherNameLocal": "Имя матери местное",
  "EXTRACTED_FIELDS_FatherNameLocal": "Отчество Местное",
  "EXTRACTED_FIELDS_AddressFullLocal": "Адрес Полный Местный",
  "EXTRACTED_FIELDS_MiddleNameLocal": "Отчество местное",
  "EXTRACTED_FIELDS_AddressLine1Local": "Адресная строка 1 Место",
  "EXTRACTED_FIELDS_AddressLine2Local": "Адресная строка 2 Местный",
  "EXTRACTED_FIELDS_AddressLine3Local": "Адресная строка 3 Местный",
  "EXTRACTED_FIELDS_IndRefNumber1": "Индивидуальный номер ссылки 1",
  "EXTRACTED_FIELDS_IndRefNumber2": "Индивидуальный номер ссылки 2",
  "EXTRACTED_FIELDS_IndRefNumber3": "Индивидуальный номер ссылки 3",
  "EXTRACTED_FIELDS_IndRefNumber4": "Индивидуальный номер ссылки 4",
  "EXTRACTED_FIELDS_IndRefNumber5": "Индивидуальный номер ссылки 5",
  "EXTRACTED_FIELDS_Name1": "Имя 1",
  "EXTRACTED_FIELDS_Name2": "Имя 2",
  "EXTRACTED_FIELDS_Name3": "Имя 3",
  "EXTRACTED_FIELDS_Name4": "Имя 4",
  "EXTRACTED_FIELDS_Name5": "Имя 5",
  "EXTRACTED_FIELDS_RECIPIENT_NAME_1": "Имя получателя 1",
  "EXTRACTED_FIELDS_RECIPIENT_NAME_2": "Имя получателя 2",
  "EXTRACTED_FIELDS_RECIPIENT_NAME_3": "Имя получателя 3",
  "EXTRACTED_FIELDS_RECIPIENT_NAME_4": "Имя получателя 4",
  "EXTRACTED_FIELDS_RECIPIENT_ADDRESS_FULL": "Адрес получателя Полный",
  "EXTRACTED_FIELDS_IBAN": "IBAN Номер счета",
  "EXTRACTED_FIELDS_ACCOUNT_NUM": "Номер счета",
  "EXTRACTED_FIELDS_ISSUER": "Эмитент",
  "EXTRACTED_FIELDS_RECIPIENT_ADDRESS_CITY": "Адрес получателя Город",
  "EXTRACTED_FIELDS_RECIPIENT_ADDRESS_POST_CODE": "Адрес получателя Почтовый индекс",
  "EXTRACTED_FIELDS_DAY": "День",
  "EXTRACTED_FIELDS_MONTH": "Месяц",
  "EXTRACTED_FIELDS_YEAR": "Год",
  "EXTRACTED_FIELDS_OPTIONAL_VALUE_1": "Необязательное значение 1",
  "EXTRACTED_FIELDS_OPTIONAL_VALUE_2": "Необязательное значение 2",
  "EXTRACTED_FIELDS_OPTIONAL_VALUE_3": "Необязательное значение 3",
  "EXTRACTED_FIELDS_OPTIONAL_VALUE_4": "Необязательное значение 4",
  "EXTRACTED_FIELDS_ISSUING_STATE_NAME": "Название государства-эмитента",
  "EXTRACTED_FIELDS_FRONT_DOCUMENT_TYPE_ID": "Идентификатор типа документа на лицевой стороне",
  "EXTRACTED_FIELDS_BACK_DOCUMENT_TYPE_ID": "Идентификатор типа документа с обратной стороны",
  "HASNOCAMERA_TITLE": "Упс, мы не смогли распознать камеру на вашем устройстве!",
  "HASNOCAMERA_DESCRIPTION": "Похоже, что на вашем устройстве нет камеры, пожалуйста, повторите попытку на другом устройстве с работающей камерой, чтобы вы смогли выполнить все необходимые действия.",
  "EXTRACTED_FIELDS_COVIDPASSCROSSCHECKRESULT": "Идентификатор типа Covid",
  "USER_INPUT_FIRST_NAME": "Первое имя",
  "USER_INPUT_MIDDLE_NAME": "Среднее имя",
  "USER_INPUT_LAST_NAME": "Фамилия",
  "USER_INPUT_DOB": "Дата рождения",
  "USER_INPUT_HOUSE_NAME_NUMBER": "Название/номер дома*",
  "USER_INPUT_STREET_NAME": "Название улицы*",
  "USER_INPUT_TOWN": "Город*",
  "USER_INPUT_POSTAL_CODE": "Почтовый индекс*",
  "USER_INPUT_HOUSE_NAME_NUMBER_EXAMPLE": "например, дом/35",
  "USER_INPUT_STREET_NAME_EXAMPLE": "например, Тестовая улица",
  "USER_INPUT_TOWN_EXAMPLE": "например, Somewhere",
  "USER_INPUT_POSTAL_CODE_EXAMPLE": "например, CH496 (без пробелов)",
  "SYSTEM_NOT_ABLE": "Система не смогла сканировать документ",
  "TRY_AGAIN": "Попробуйте еще раз",
  "HINTS_DISABLED_HEADER": "Подсказки отключены в ручном режиме",
  "HINTS_DISABLED_DESCRIPTION": "Если вы хотите включить подсказки для фотографирования, переключитесь в режим АВТОМАТИЧЕСКОГО ФОТОГРАФИРОВАНИЯ",
  "YOU_HAVE": "У вас есть",
  "PICTURE_VERIFYING": "Проверка...",
  "HOW_TO_TAKE_PHOTO_CORRECTLY": "Как сделать правильное фото",
}